// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"23a7dc10","857":"44f4b707","977":"0296d865"}[chunkId] + ".chunk.js";
};